import { useEffect } from 'react';

import { useFormDataQuery } from '@/api/getters';
import ThankYouNoQualifyFallback from '@/features/v2/vehicle-damage/components/thankYou/ThankYouNoQualifyFallback';
import ThankYouNoQualifySettlement from '@/features/v2/vehicle-damage/components/thankYou/ThankYouNoQualifySettlement';
import ThankYouNoQualifyUnder10K from '@/features/v2/vehicle-damage/components/thankYou/ThankYouNoQualifyUnder10K';
import ThankYouNotQualifyForeignIssuer from '@/features/v2/vehicle-damage/components/thankYou/ThankYouNotQualifyForeignIssuer';
import { VehicleDamageSchemaDeadEndsStepOne } from '@/features/v2/vehicle-damage/stepsSchema';
import { VehicleDamageSchemaDeadEndsStepOneComplementary } from '@/features/v2/vehicle-damage/summarySchema';
import {
  getUserType,
  vehicleDamageDataLayer,
} from '@/helpers/addStageToDataLyer';

const NotQualify = () => {
  // This component uses data directly from the backend (which is ensured to be the same due to revalidation)
  // instead of using the 'watch' function. This is because this component is higher in the hierarchy than the form component.
  const { data } = useFormDataQuery();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formData = data?.payload?.data as Record<any, any>;

  const UNDER_10K =
    VehicleDamageSchemaDeadEndsStepOne.radioGroupVehicleValueBeforeCrash.condition(
      formData
    ) ||
    VehicleDamageSchemaDeadEndsStepOneComplementary.radioGroupVehicleValueBeforeCrash.condition(
      formData
    );

  const SETTLEMENT =
    VehicleDamageSchemaDeadEndsStepOne.fullAgreementOrSettlementConcluded.condition(
      formData
    ) ||
    VehicleDamageSchemaDeadEndsStepOne.AgreementOrSettlementConcluded.condition(
      formData
    ) ||
    VehicleDamageSchemaDeadEndsStepOneComplementary.fullAgreementOrSettlementConcluded.condition(
      formData
    ) ||
    VehicleDamageSchemaDeadEndsStepOneComplementary.AgreementOrSettlementConcluded.condition(
      formData
    );

  const FOREIGN_INSURANCE =
    VehicleDamageSchemaDeadEndsStepOne.noPolishInsurance.condition(formData) ||
    VehicleDamageSchemaDeadEndsStepOneComplementary.noPolishInsurance.condition(
      formData
    );

  const userType = getUserType(data);

  useEffect(() => {
    if (FOREIGN_INSURANCE) {
      vehicleDamageDataLayer.notQualified(
        'zagraniczny_ubezpieczyciel',
        'not_qaulify',
        userType
      );
      return;
    }
    if (UNDER_10K) {
      vehicleDamageDataLayer.notQualified(
        'wartość_pojazdu_poniżej_10k',
        'not_qaulify',
        userType
      );
      return;
    }
    if (SETTLEMENT) {
      vehicleDamageDataLayer.notQualified('ugoda', 'not_qaulify', userType);
      return;
    }
    vehicleDamageDataLayer.notQualified(
      'brak_kwalifikacji',
      'not_qaulify',
      userType
    );
  }, [FOREIGN_INSURANCE, UNDER_10K, SETTLEMENT, userType]);

  if (FOREIGN_INSURANCE) {
    return <ThankYouNotQualifyForeignIssuer />;
  }

  if (UNDER_10K) {
    return <ThankYouNoQualifyUnder10K />;
  }

  if (SETTLEMENT) {
    return <ThankYouNoQualifySettlement />;
  }

  return <ThankYouNoQualifyFallback />;
};

export default NotQualify;
